import { render, staticRenderFns } from "./cmp-mdc-data-search.vue?vue&type=template&id=2bd475ca&"
import script from "./cmp-mdc-data-search.vue?vue&type=script&lang=ts&"
export * from "./cmp-mdc-data-search.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./cmp-mdc-data-search.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports